import React, { useState } from 'react';
import { Input, PhoneInput, Select, Button } from './UI';

const BUXORO_TUMANLARI = [
  { value: '', label: "Tuman/Shaharni tanlang" },
  { value: 'Buxoro shahri', label: 'Buxoro shahri' },
  { value: 'Kogon shahri', label: 'Kogon shahri' },
  { value: 'Olot tumani', label: 'Olot tumani' },
  { value: 'Buxoro tumani', label: 'Buxoro tumani' },
  { value: 'Vobkent tumani', label: 'Vobkent tumani' },
  { value: "G'ijduvon tumani", label: "G\u2018ijduvon tumani" },
  { value: 'Kogon tumani', label: 'Kogon tumani' },
  { value: "Qorako'l tumani", label: "Qorako\u2018l tumani" },
  { value: 'Qorovulbozor tumani', label: 'Qorovulbozor tumani' },
  { value: 'Peshku tumani', label: 'Peshku tumani' },
  { value: 'Romitan tumani', label: 'Romitan tumani' },
  { value: 'Jondor tumani', label: 'Jondor tumani' },
  { value: 'Shofirkon tumani', label: 'Shofirkon tumani' },
];

const BUXORO_TUMANLARI_WITH_VILOYAT = [
  { value: '', label: "Tuman/Shaharni tanlang" },
  { value: 'Buxoro viloyati', label: 'Buxoro viloyati' },
  { value: 'Buxoro shahri', label: 'Buxoro shahri' },
  { value: 'Kogon shahri', label: 'Kogon shahri' },
  { value: 'Olot tumani', label: 'Olot tumani' },
  { value: 'Buxoro tumani', label: 'Buxoro tumani' },
  { value: 'Vobkent tumani', label: 'Vobkent tumani' },
  { value: "G'ijduvon tumani", label: "G\u2018ijduvon tumani" },
  { value: 'Kogon tumani', label: 'Kogon tumani' },
  { value: "Qorako'l tumani", label: "Qorako\u2018l tumani" },
  { value: 'Qorovulbozor tumani', label: 'Qorovulbozor tumani' },
  { value: 'Peshku tumani', label: 'Peshku tumani' },
  { value: 'Romitan tumani', label: 'Romitan tumani' },
  { value: 'Jondor tumani', label: 'Jondor tumani' },
  { value: 'Shofirkon tumani', label: 'Shofirkon tumani' },
];

export default function UserForm({ user, onSave, onClose }) {
  const isEdit = !!user;
  const [form, setForm] = useState({
    role: user?.role || 'tuman_admin',
    first_name: user?.first_name || '',
    last_name: user?.last_name || '',
    username: user?.username || '',
    password: '',
    password_confirm: '',
    phone: user?.phone || '',
    tuman: user?.tuman || '',
    tashkilot_nomi: user?.tashkilot_nomi || '',
    lavozim: user?.lavozim || '',
  });
  const [error, setError] = useState('');

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleSave = () => {
    if (!form.first_name || !form.last_name || !form.username) {
      setError("Ism, familiya va login to'ldirilishi shart");
      return;
    }
    if (!isEdit && !form.password) {
      setError("Parol kiritilishi shart");
      return;
    }
    if (form.password && form.password !== form.password_confirm) {
      setError("Parollar bir xil emas");
      return;
    }
    if (form.password && form.password.length < 6) {
      setError("Parol kamida 6 ta belgidan iborat bo'lishi kerak");
      return;
    }
    if (!form.tuman) {
      setError("Tuman/Shaharni tanlang");
      return;
    }
    setError('');
    const data = { ...form };
    delete data.password_confirm;
    if (isEdit && !data.password) delete data.password;
    onSave(data);
  };

  return (
    <div>
      {error && <div style={{ padding: '10px 16px', borderRadius: 10, background: '#fee2e2', color: 'var(--red)', fontSize: 13, fontWeight: 500, marginBottom: 16 }}>{error}</div>}

      <Select label="Foydalanuvchi turi" value={form.role} onChange={v => set('role', v)} required options={[
        { value: 'tuman_admin', label: 'Tuman/Shahar administratori' },
        { value: 'idora', label: 'Idora va tashkilotlar' },
      ]} />

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        <Input label="Ism" value={form.first_name} onChange={v => set('first_name', v)} placeholder="Ism" required />
        <Input label="Familiya" value={form.last_name} onChange={v => set('last_name', v)} placeholder="Familiya" required />
      </div>

      <Input label="Login" value={form.username} onChange={v => set('username', v)} placeholder="login_nomi" required disabled={isEdit} />

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        <Input label={isEdit ? "Yangi parol (ixtiyoriy)" : "Parol"} value={form.password} onChange={v => set('password', v)} type="password" placeholder="••••••••" required={!isEdit} />
        <Input label="Parol tasdig'i" value={form.password_confirm} onChange={v => set('password_confirm', v)} type="password" placeholder="••••••••" required={!isEdit} />
      </div>

      <PhoneInput label="Telefon" value={form.phone} onChange={v => set('phone', v)} />

      {form.role === 'tuman_admin' ? (
        <Select label="Tuman/Shahar" value={form.tuman} onChange={v => set('tuman', v)} required options={BUXORO_TUMANLARI} />
      ) : (
        <>
          <Select label="Tuman/Shahar" value={form.tuman} onChange={v => set('tuman', v)} required options={BUXORO_TUMANLARI_WITH_VILOYAT} />
          <Input label="Tashkilot nomi" value={form.tashkilot_nomi} onChange={v => set('tashkilot_nomi', v)} placeholder="Masalan: Bandlik markazi" />
          <Input label="Lavozim" value={form.lavozim} onChange={v => set('lavozim', v)} placeholder="Masalan: Bo'lim boshlig'i" />
        </>
      )}

      <div style={{ display: 'flex', gap: 12, marginTop: 8, justifyContent: 'flex-end' }}>
        <Button variant="ghost" onClick={onClose}>Bekor qilish</Button>
        <Button onClick={handleSave} icon={isEdit ? 'check' : 'plus'}>{isEdit ? "Saqlash" : "Yaratish"}</Button>
      </div>
    </div>
  );
}
